import { Brick, BrickContext, registerBrick, ErrorFlow } from 'olympe';
import { getLogger } from '@olympeio/core';

export default class LockScreenOrientation extends Brick {

    static validOrientations = new Set(['any', 'natural', 'portrait', 'landscape', 'portrait-primary', 'portrait-secondary', 'landscape-primary', 'landscape-secondary']);

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} orientation
     * @param {function()} forwardEvent
     * @param {function(ErrorFlow)} setError
     */
    async update($, [orientation], [forwardEvent, setError]) {
        const logger = getLogger('LockScreenOrientation');
        if (!screen.orientation.lock) {
            logger.warn(`screen.orientation.lock is not available in the browser => ignore locking but continue without error`);
            forwardEvent();
            return;
        }
        if (!LockScreenOrientation.validOrientations.has(orientation)) {
            const msg = `Invalid orientation input: ${orientation}, must be one of: ${Array.from(LockScreenOrientation.validOrientations).join(', ')}`
            logger.error(msg);
            setError(ErrorFlow.create(msg), 1)
            return;
        }
        try {
            await screen.orientation.lock(orientation);
            forwardEvent();
        } catch (error) {
            const msg = `Failed to lock screen orientation: ${error}`
            logger.error(msg);
            setError(ErrorFlow.create(msg), 2);
        }
    }
}

registerBrick('018adfbd57fedc70a9a8', LockScreenOrientation);
